import { render, staticRenderFns } from "./PolicyAreaListDetail.vue?vue&type=template&id=5d68aede"
import script from "./PolicyAreaListDetail.js?vue&type=script&lang=js&external"
export * from "./PolicyAreaListDetail.js?vue&type=script&lang=js&external"
import style0 from "./PolicyAreaListDetail.vue?vue&type=style&index=0&id=5d68aede&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports